import WhyUs from "../Components/Other/WhyUs";

const WhyUsPage = () => {
  return <WhyUs />;
};

export default WhyUsPage;
